// Presentation-only translations. Hotel-defined names and API values stay unchanged.
const reservationDraftMessages = {
  "Reservation": "Reserva",
  "Protected draft": "Borrador protegido",
  "This reservation was opened from an existing room block. The protected slot stays blocked until the reservation group is confirmed.": "Esta reserva se ha creado a partir de un bloqueo de habitación. La habitación permanece bloqueada hasta que se confirme el grupo de reservas.",
  "Waitlist lead:": "Contacto de la lista de espera:",
  "Guest": "Huésped",
  "Manual modification limits": "Límites de modificación manual",
  "Dates": "Fechas",
  "Check-In → Check-Out": "Entrada → Salida",
  "Click to Select Dates": "Seleccionar fechas",
  "Nights": "Noches",
  "Occupancy": "Ocupación",
  "Adults": "Adultos",
  "Select": "Seleccionar",
  "Select Adults": "Seleccionar adultos",
  "Choose how many adults will stay in this reservation.": "Indica cuántos adultos se alojarán en esta reserva.",
  "No options available": "No hay opciones disponibles",
  "Children": "Niños",
  "Select Children": "Seleccionar niños",
  "Set the number of children for the selected stay.": "Indica el número de niños para la estancia seleccionada.",
  "Babies": "Bebés",
  "Room and Rates": "Habitación y tarifas",
  "Room Category": "Categoría de habitación",
  "Click to Select Category": "Seleccionar categoría",
  "Category #{id}": "Categoría n.º {id}",
  "Accommodation": "Alojamiento",
  "Select Room Category": "Seleccionar categoría de habitación",
  "Pick the category that best matches the reservation.": "Elige la categoría que mejor se adapte a la reserva.",
  "No categories available.": "No hay categorías disponibles.",
  "Room Suggested": "Habitación sugerida",
  "Suggested room selected": "Habitación sugerida seleccionada",
  "Click to Select Suggested Room Number": "Seleccionar número de habitación sugerida",
  "Select Suggested Room": "Seleccionar habitación sugerida",
  "Unassign room": "Quitar número de habitación",
  "Keep the room category and leave the room number unassigned.": "Mantiene la categoría y deja el número de habitación sin asignar.",
  "Review available and occupied rooms before applying the suggestion.": "Revisa las habitaciones disponibles y ocupadas antes de aplicar la sugerencia.",
  "No rooms found.": "No se han encontrado habitaciones.",
  "Available": "Disponibles",
  "Occupied / Blocked": "Ocupadas / Bloqueadas",
  "Room": "Habitación",
  "Floor": "Planta",
  "Bed type": "Tipo de cama",
  "View": "Vistas",
  "Select Room Category First": "Selecciona primero una categoría de habitación",
  "Room Rate": "Tarifa de habitación",
  "Click to Select Room Rate": "Seleccionar tarifa de habitación",
  "Rate #{id}": "Tarifa n.º {id}",
  "Pricing": "Precios",
  "Select Room Rate": "Seleccionar tarifa de habitación",
  "Select the pricing rule to apply to the reservation.": "Selecciona la tarifa que se aplicará a la reserva.",
  "No room rates available.": "No hay tarifas de habitación disponibles.",
  "No valid room rates ({code}): {reason}": "No hay tarifas válidas ({code}): {reason}",
  "No valid room rates: {reason}": "No hay tarifas válidas: {reason}",
  "No valid room rates ({code}).": "No hay tarifas válidas ({code}).",
  "No valid room rates. Details: {details}": "No hay tarifas válidas. Detalles: {details}",
  "No rates match the selected dates, occupancy and room category.": "No hay tarifas que coincidan con las fechas, la ocupación y la categoría de habitación seleccionadas.",
  "Remove overrides and restore base nightly prices": "Quitar los ajustes manuales y restaurar los precios base por noche",
  "Select a Room Rate first": "Selecciona primero una tarifa de habitación",
  "Apply overrides to nightly prices": "Aplicar ajustes manuales a los precios por noche",
  "Remove Override": "Quitar ajuste manual",
  "Apply Override": "Aplicar ajuste manual",
  "Room Price (": "Precio de la habitación (",
  "Pending": "Pendiente",
  "Extras details": "Detalle de extras",
  "No extras": "Sin extras",
  "Manage Extras": "Gestionar extras",
  "Select a Room Rate first to manage extras": "Selecciona primero una tarifa de habitación para gestionar los extras",
  "Total Extras (": "Total de extras (",
  "Total applied extras": "Total de extras aplicados",
  "Final Total Price (": "Precio total final (",
  "Reservation total including extras": "Total de la reserva, incluidos los extras",
  "Extras and Notes": "Extras y notas",
  "Check-in Time": "Hora de entrada",
  "Check-out Time": "Hora de salida",
  "Special Requests": "Peticiones especiales",
  "Reservation Status": "Estado de la reserva",
  "Save Reservation": "Guardar reserva",
  "Close": "Cerrar",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "Edit Stay Dates": "Editar fechas de estancia",
  "Update the check-in and check-out dates without changing any reservation logic.": "Actualiza las fechas de entrada y salida de la reserva.",
  "Close date editor": "Cerrar el editor de fechas",
  "Check-in": "Entrada",
  "Check-out": "Salida",
  "Select check-in": "Seleccionar entrada",
  "Select check-out": "Seleccionar salida",
  "Selected check-in date": "Fecha de entrada seleccionada",
  "Selected check-out date": "Fecha de salida seleccionada",
  "Select the stay:": "Selecciona la estancia:",
  "choose the check-in date first, then the check-out date.": "elige primero la fecha de entrada y después la de salida.",
  "night": "noche",
  "nights": "noches",
  "Previous month": "Mes anterior",
  "Next month": "Mes siguiente",
  "Choose": "Seleccionar",
  "Not available": "No disponible",
  "Month": "Mes",
  "Week": "Semana",
  "Reservations with Group Rate cannot be modified. Please delete and create a new reservation.": "Las reservas con tarifa de grupo no se pueden modificar. Elimina la reserva y crea una nueva.",
  "Error loading adults options.": "No se han podido cargar las opciones de adultos.",
  "Error saving adults.": "No se ha podido guardar el número de adultos.",
  "Error loading children options.": "No se han podido cargar las opciones de niños.",
  "Error saving children.": "No se ha podido guardar el número de niños.",
  "Error saving babies.": "No se ha podido guardar el número de bebés.",
  "Error loading room categories.": "No se han podido cargar las categorías de habitación.",
  "Availability has changed. Please select dates again.": "La disponibilidad ha cambiado. Selecciona las fechas de nuevo.",
  "Error saving room category.": "No se ha podido guardar la categoría de habitación.",
  "Error fetching room suggestion options.": "No se han podido cargar las habitaciones sugeridas.",
  "Error saving room.": "No se ha podido guardar la habitación.",
  "Select dates first.": "Selecciona primero las fechas.",
  "Select number of adults first.": "Selecciona primero el número de adultos.",
  "Error loading room rates.": "No se han podido cargar las tarifas de habitación.",
  "Error saving rate.": "No se ha podido guardar la tarifa.",
  "Error removing overrides.": "No se han podido quitar los ajustes manuales.",
  "Please select both dates.": "Selecciona las fechas de entrada y salida.",
  "Check-out must be after check-in.": "La fecha de salida debe ser posterior a la de entrada.",
  "No availability for the selected dates.": "No hay disponibilidad para las fechas seleccionadas.",
  "Error saving dates.": "No se han podido guardar las fechas.",
};

export default reservationDraftMessages;
